import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { isMutationAndQueriesV2Enabled } from "Worksheet/modules/WorksheetUtils";
export default () => {
  const isV2 = isMutationAndQueriesV2Enabled();
  return {
    path: isV2 ? ":question_id" : ":question_resource_id",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "worksheet-question-library" */ "./components"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      //.catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
